import { Col, Descriptions, Modal, Row, Spin } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { RootState } from '../../modules';
import { getPartnerDetailAsync } from '../../modules/partners';
import { phoneFormatter } from '../../util/utils';

const StyledDiv = styled.div``;

interface PartnerDetailModalProps {
  visible: boolean;
  enterpriseId: string;
  projectId: string;
  partnerId: string;
  onCancel: () => void;
}

function PartnerDetailModal({
  visible,
  enterpriseId,
  projectId,
  partnerId,
  onCancel,
}: PartnerDetailModalProps) {
  const dispatch = useDispatch();
  const { data, loading } = useSelector(
    (state: RootState) => state.partners.partner,
  );
  useEffect(() => {
    dispatch(
      getPartnerDetailAsync.request({ enterpriseId, projectId, partnerId }),
    );
  }, [dispatch, enterpriseId, projectId, partnerId]);

  return (
    <StyledDiv>
      <Modal open={visible} footer={null} onCancel={onCancel}>
        {loading && <Spin />}
        {data && (
          <>
            <Row>
              <Col flex={1}>
                <Descriptions
                  title="참여업체 상세 정보"
                  bordered
                  column={2}
                  size="small"
                >
                  <Descriptions.Item label="회사명" span={2}>
                    {data.name}
                  </Descriptions.Item>
                  <Descriptions.Item label="대표명">
                    {data.representative}
                  </Descriptions.Item>
                  <Descriptions.Item label="주소">
                    {data.address}
                  </Descriptions.Item>
                  <Descriptions.Item label="연락처">
                    {phoneFormatter(data.corporatePhone, 1)}
                  </Descriptions.Item>
                  <Descriptions.Item label="사업자등록번호">
                    {data.corporateNumber}
                  </Descriptions.Item>
                  <Descriptions.Item label="공정" span={2}>
                    <ul>
                      {data.type2 === null
                        ? null
                        : data.type2.map((tag, index) => (
                            <li key={index}>{tag}</li>
                          ))}
                    </ul>
                  </Descriptions.Item>
                  <Descriptions.Item label="공사 참여직원" span={2}>
                    <ul>
                      {data.employees.map((employee, index) => (
                        <li key={index}>
                          {employee.name} ({employee.email})
                        </li>
                      ))}
                    </ul>
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            </Row>
          </>
        )}
      </Modal>
    </StyledDiv>
  );
}

export default PartnerDetailModal;
